import { Checks, Copy, WarningCircle, X } from "@phosphor-icons/react";
import React from "react";
import dayjs from "dayjs"; // Use for date/time formatting
import { formatHotel } from "../../api/hotelTime";
import PromoBreakdown from "../Dashboard/PromoBreakdown";
 
const PreEarlyCheckinModal = ({requestData,setRequestType,setOpenRequestModal,setRequestData}) => {
  
    // Format the date and time
    const tripDate = formatHotel(requestData.proposed_checkin_time, "DD MMMM YYYY");
    const tripTime = formatHotel(requestData.proposed_checkin_time, "hh:mm A");

    // Close Modal
    const closeModal=()=>{
        try{
            setOpenRequestModal(false);
            setRequestType("");
            setRequestData(null);
            
        }catch(error){
            console.log(error);
        }
    }

   

    return (
        <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[1001]">
            <div
                className="popup-content bg-white p-6 rounded-lg text-sm flex flex-col gap-2 w-[80%] md:w-[70%] lg:w-[50%]">
                
                {/*  Request Header */}
                <div className="flex items-center justify-between">
                    <h2 className="text-xl font-semibold">
                        Early CheckIn Request
                    </h2>
                    <button
                        className="hover:bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                        type="button"
                        onClick={()=>closeModal()}
                    >
                        <X weight="bold" size={18} />
                    </button>
                </div>

                <div className="flex flex-col gap-4">

                    {/* Room Details */}
                    <div className="flex items-center justify-between">
                 
                        <div className="w-1/3">
                            <p className="text-[#8C9199] mb-2">
                                Room ID
                            </p>
                            <div className="flex items-center gap-2">
                                <p
                                    className="truncate w-[70%]"
                                >
                                    {
                                        requestData?.booked_room_id || "room ID"
                                    }
                                </p>
                            </div>
                        </div>
                                
                        {requestData.proposed_checkin_time && 
                            <div className="w-1/3">
                                <p className="text-[#8C9199] mb-2">Requested Date</p>
                                <p>{tripDate}</p>
                            </div>
                        }

                        {requestData.proposed_checkin_time && 
                            <div className="w-1/3">
                                <p className="text-[#8C9199] mb-2">
                                    Requested Time
                                </p>
                                <p>{tripTime}</p>
                            </div>
                        }
                    </div>
                    
 

                    {/* Fees and other Details */}
                    {requestData?.price !== null && requestData?.price !== undefined &&
                        <div className="flex gap-6">
                            <div className="">
                                <p className="text-[#8C9199] mb-2">Hours Early</p>
                                <p>
                                    {requestData?.hours_early || 0} {requestData?.hours_early === 1 ? "hour" : "hours"}
                                    {requestData?.hourly_rate ? ` × ₹${requestData.hourly_rate}` : ""}
                                </p>
                            </div>
                            <div className="">
                                <p className="text-[#8C9199]">Fee</p>
                                <div className="flex gap-3 w-full items-center">
                                    <input
                                        type="text"
                                        value={requestData?.price ?? ""}
                                        placeholder="Enter amount"
                                        className="px-2 py-1.5 rounded-md border-[1.5px]"
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    
                    <PromoBreakdown
                        grossAmount={requestData?.price}
                        taxAmount={requestData?.tax_amount}
                        discountAmount={requestData?.discount_amount}
                        promotionId={requestData?.promotion_id}
                    />

                    {/* Remarks */}
                    {requestData?.remarks && 
                        <div>
                            <p className="text-[#8C9199] mb-1">Remarks</p>
                            <textarea
                                value={requestData?.remarks || ""}
                                rows={4}
                                className="w-full border-[1.5px] rounded-md p-2"
                                placeholder="Please leave your remarks here"
                                disabled
                            ></textarea>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default PreEarlyCheckinModal;
